import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router';
import {actions} from "../user/actions";
import * as Model from '../user/model';
import axios from "axios";
import {FormattedMessage, InjectedIntlProps, injectIntl} from "react-intl";
import {copyOidcUserToCurrentUser, userManager} from "./utils/userManager";
import {Redirect} from "react-router-dom";
import {processSilentRenew} from "redux-oidc";
import {LAST_SILENT_RENEW, localRepository} from "../common/LocalRepository";
import {oidcUtils} from "./utils/OidcUtils";

interface SilentRenewPageProps {
  dispatch: (action) => any;
}

export class SilentRenewPageComponent extends React.Component<SilentRenewPageProps & RouteComponentProps<any> & InjectedIntlProps> {
  updatedUserAndToken = (user: Oidc.User) => {
    try {
      if (user && user.profile) {
        const token = oidcUtils.getOidcTokenValue();
        axios.interceptors.request.clear();
        axios.interceptors.request.use(c => {
          c.headers.Authorization = "Bearer " + token
          return c;
        });
        const currentUser: Model.User = copyOidcUserToCurrentUser(user);
        this.props.dispatch(actions.setUser(currentUser));
      }
    } catch (error) {
      throw new Error("Error occurred during renewal of user and/or token : " + error);
    }
  }

  componentDidMount() {
    processSilentRenew();
    userManager.getUser().then((oidcUser: Oidc.User) => {
      this.updatedUserAndToken(oidcUser);
    });
  }

  render() {
    localRepository.setParameter(LAST_SILENT_RENEW, Date.now().toString(10));
    return (
        <Redirect
            to={{
              pathname: "/",
            }}><FormattedMessage id="studio.oidc.callback.redirect" defaultMessage="Redirecting..."/></Redirect>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch
  };
}
export const SilentRenewPage = connect(null, mapDispatchToProps)(withRouter(injectIntl(SilentRenewPageComponent)));